import { cleanURL, getQueryParam } from '../utils/functions';

class Library {
	constructor(className) {
		this.sections = document.querySelectorAll(`.${className}`);
		this.sections.forEach((section) => {
			new Section(section);
		});
	}
}

class Section {
	// BOOKS DEFAULT STYLE
	width = 250;
	marginX = 80;
	marginY = 114;

	constructor(section) {
		// SECTION ELEMENTS
		this.section = section;
		this.booksWrapper = section.querySelector('.library__books');
		this.searchInput = section.querySelector('.search__input');
		this.searchButton = section.querySelector('.search__button');
		this.searchForm = section.querySelector('.search__form');
		this.noResultsWrapper = section.querySelector('.library__no-results');

		// GET SEARCH QUERY PARAM
		this.getSearchParam();

		// GET BOOKS
		this.books = this.getBooks();

		// GET BOOKS PER ROWS
		this.booksPerRow = this.getBooksPerRow();

		// EVENTS
		window.addEventListener('resize', this.handleResize);
		this.searchInput.addEventListener('keyup', this.filterBooks);
		this.searchForm.addEventListener('submit', this.filterBooks);

		// FILTER & RENDER
		this.filterBooks();

		setTimeout(() => this.handleResize(), 500);
	}

	getSearchParam() {
		const search = getQueryParam('search');
		if (search) {
			this.searchInput.value = search;
		}

		cleanURL();
	}

	getBooks() {
		const books = this.section.querySelectorAll('.library__book');

		return Array.prototype.slice.call(books).map((el) => {
			const data = JSON.parse(el.dataset.book);
			return { el, ...data };
		});
	}

	getBooksPerRow = () =>
		Math.floor((this.booksWrapper.clientWidth + this.marginX * 2) / (this.width + this.marginX * 2)) || 1;

	handleResize = () => {
		this.booksPerRow = this.getBooksPerRow();
		this.render();
	};

	filterBooks = (ev) => {
		if (ev) ev.preventDefault();

		this.books.forEach((book, index) => (this.books[index].visible = this.isBookVisible(book)));
		this.render();
	};

	isBookVisible(book) {
		const searchValue = this.searchInput.value.regexpAccentify();

		if (
			searchValue.length === 0 ||
			book.title.regexpAccentify().includes(searchValue) ||
			book.authors.regexpAccentify().includes(searchValue) ||
			book.editor.regexpAccentify().includes(searchValue) ||
			book.keywords.regexpAccentify().includes(searchValue)
		) {
			return true;
		}

		return false;
	}

	render() {
		const books = [];
		this.books.forEach((book) => (book.visible === true ? books.push(book) : this.hide(book)));

		const rows = [];
		while (books.length > 0) {
			const row = books.splice(0, this.booksPerRow);
			const elements = row.map((book) => book.el);
			rows.push({
				elements,
				height: Math.max(...elements.map((el) => el.clientHeight)),
			});
		}

		// Set books positions
		for (let i in rows) {
			const row = rows[i];
			const rowTopPosition = rows
				.slice(0, i)
				.map((row) => row.height + this.marginY)
				.reduce((a, b) => a + b, 0);

			row.elements.forEach((el, index) => {
				const usableSpace = this.booksWrapper.clientWidth / this.booksPerRow;
				const startPositionInUsabledSpace = (usableSpace - this.width) / 2;
				const leftPosition = usableSpace * index + startPositionInUsabledSpace;

				el.style.opacity = 1;
				el.style.width = `${this.width}px`;
				el.style.left = `${leftPosition}px`;
				el.style.top = `${rowTopPosition}px`;
			});
		}

		// Set books container height
		const booksWrapperHeight = rows.reduce((a, b) => a + b.height + this.marginY, 0);
		this.booksWrapper.style.height = booksWrapperHeight ? `${booksWrapperHeight}px` : 'auto';

		// Hide / Display no results text
		this.noResultsWrapper.style.display = booksWrapperHeight ? 'none' : 'block';
	}

	hide(book) {
		book.el.style.opacity = 0;
		book.el.style.top = this.booksWrapper.clientHeight + 'px';
	}
}

export default Library;
